<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><img alt="Racing the Rain: A Novel, by John L Parker. Scribner." class="imagefp" src="images/title.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?06cc58f5